/**
 * Derives student role id and whether the current form role is student (SRP: role semantics for admin user forms).
 */
export function useStudentRoleSelection(roles, formDataRole) {
  const studentRole = roles.find((r) => {
    if (typeof r === 'string') return r === 'student';
    return r.value === 'student' || r === 'student';
  });

  const studentRoleId =
    studentRole == null
      ? undefined
      : typeof studentRole === 'object'
        ? studentRole.id || studentRole._id
        : studentRole;

  const isStudentRole = Boolean(
    formDataRole &&
      (formDataRole === 'student' ||
        formDataRole === studentRoleId ||
        (studentRoleId != null && formDataRole?.toString() === studentRoleId.toString()))
  );

  return { studentRoleId, isStudentRole };
}
